import React, { useReducer } from 'react';
import { Box } from 'reflexbox';
import { HealtheraButton } from '../../../healtheraComponents';
import TextField from '@material-ui/core/TextField'
import { useDispatch, useSelector } from 'react-redux';
import * as branchActions from '../../../redux/branches';

export default function MedpointIntegrationForm({ pharmacyId }) {
  const { medpointIntegration } = useSelector(state => state.branches);

  const dispatch = useDispatch();

  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    { client_id: '', client_secret: '' }
  );

  const handleInput = event => setFormInput({ [event.target.name]: event.target.value });

  const handleSubmit = () => {
    const payload = { ...formInput, pharmacy_id: pharmacyId };
    dispatch(branchActions.postMedpointIntegration(payload));
    dispatch(branchActions.getMedpointIntegration(pharmacyId));
  };

  return (
    <>
      <TextField
        label='Client ID'
        onChange={handleInput}
        margin='normal'
        fullWidth
        InputLabelProps={{ shrink: true }}
        name='client_id'
        disabled={medpointIntegration}
        defaultValue={formInput.client_id}
        value={medpointIntegration?.client_id}
      />
      <TextField
        label='Secret Key'
        onChange={handleInput}
        margin='normal'
        fullWidth
        InputLabelProps={{ shrink: true }}
        name='client_secret'
        disabled={medpointIntegration}
        defaultValue={formInput.client_secret}
        value={medpointIntegration?.client_secret}
      />
      <Box mt={2}>
        <HealtheraButton
          width={'95px'}
          onClick={handleSubmit}
          disabled={Object.values(formInput).includes('') || medpointIntegration}
        >Save
        </HealtheraButton>
      </Box>
    </>
  )
}
